import React, { useState, useEffect } from 'react';
import Modal from '../../../components/Modal';
import TimeInput from '../../../components/common/TimeInput';
import { getMeetingDisplayName, formatScheduledAt } from '../utils/meetingTemplates';

const RescheduleMeetingModal = ({
  isOpen,
  onClose,
  meeting,
  onReschedule
}) => {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (meeting?.scheduledAt) {
      const d = new Date(meeting.scheduledAt);
      setDate(d.toISOString().split('T')[0]);
      setTime(`${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`);
    }
  }, [meeting]);

  const handleSubmit = async () => {
    if (!date || !time) {
      alert('Välj både datum och tid');
      return;
    }

    try {
      setSaving(true);
      await onReschedule(meeting._id, { date, time });
      onClose();
    } catch (err) {
      console.error('Fel vid ombokning:', err);
      alert(err.response?.data?.message || 'Kunde inte boka om mötet');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small">
          <h2 className="text-lg font-semibold text-gray-900">
            Ändra tid
          </h2>
          <p className="text-sm text-gray-500 mt-1 mb-4">
            {getMeetingDisplayName(meeting)}
          </p>

          {/* Nuvarande tid */}
          {meeting.scheduledAt && (
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
              <div className="text-xs text-gray-500 mb-1">Nuvarande tid</div>
              <div className="text-sm font-medium text-gray-900">
                {formatScheduledAt(meeting.scheduledAt)}
              </div>
            </div>
          )}

          {/* Ny tid */}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nytt datum
              </label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                min={new Date().toISOString().split('T')[0]}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-primary focus:border-primary"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Ny tid
              </label>
              <TimeInput
                value={time}
                onChange={(e) => setTime(e.target.value)}
              />
            </div>
          </div>

          <p className="mt-4 text-xs text-gray-500">
            Kalenderinbjudan uppdateras automatiskt för alla deltagare.
          </p>

          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={onClose}
              className="px-2.5 py-1.5 sm:px-3 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Avbryt
            </button>
            <button
              onClick={handleSubmit}
              disabled={saving || !date || !time}
              className="px-2.5 py-1.5 sm:px-3 text-sm font-medium bg-leadme-pink text-white rounded-lg hover:bg-leadme-pink/90 transition-colors disabled:opacity-50 flex items-center gap-1"
            >
              <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              {saving ? 'Sparar...' : 'Boka om'}
            </button>
          </div>
    </Modal>
  );
};

export default RescheduleMeetingModal;
